module.exports = __webpack_public_path__ + "media/images/noticia06-439021009c2c4a071213e1d915ec8fd4.jpeg";